// Color mappings for category backgrounds and text
export const badgeColorMap: Record<string, { bg: string; text: string; border: string }> = {
  evergreen: {
    bg: 'bg-evergreen-100',
    text: 'text-evergreen-600',
    border: 'border-evergreen-200',
  },
  evergreenDark: {
    bg: 'bg-evergreen-200',
    text: 'text-evergreen-700',
    border: 'border-evergreen-300',
  },
  gray: {
    bg: 'bg-neutral-100',
    text: 'text-neutral-600',
    border: 'border-neutral-200',
  },
  grayDark: {
    bg: 'bg-neutral-200',
    text: 'text-neutral-700',
    border: 'border-neutral-300',
  },
  meltwater: {
    bg: 'bg-meltwater-100',
    text: 'text-meltwater-600',
    border: 'border-meltwater-200',
  },
  meltwaterDark: {
    bg: 'bg-meltwater-200',
    text: 'text-meltwater-700',
    border: 'border-meltwater-300',
  },
  navy: {
    bg: 'bg-navy-100',
    text: 'text-navy-600',
    border: 'border-navy-200',
  },
  navyDark: {
    bg: 'bg-navy-200',
    text: 'text-navy-700',
    border: 'border-navy-300',
  },
  outback: {
    bg: 'bg-outback-100',
    text: 'text-outback-700',
    border: 'border-outback-200',
  },
  outbackDark: {
    bg: 'bg-outback-200',
    text: 'text-outback-800',
    border: 'border-outback-300',
  },
  sage: {
    bg: 'bg-sage-100',
    text: 'text-sage-600',
    border: 'border-sage-200',
  },
  sageDark: {
    bg: 'bg-sage-200',
    text: 'text-sage-700',
    border: 'border-sage-300',
  },
  tuscany: {
    bg: 'bg-tuscany-100',
    text: 'text-tuscany-700',
    border: 'border-tuscany-200',
  },
  tuscanyDark: {
    bg: 'bg-tuscany-200',
    text: 'text-tuscany-800',
    border: 'border-tuscany-400',
  },
}

export const fullColorMapHSL: Record<string, Record<string, string>> = {
  evergreen: {
    50: '144 24% 96%',
    100: '131 22% 90%',
    200: '136 22% 80%',
    300: '141 21% 67%',
    400: '143 18% 52%',
    500: '146 23% 39%',
    600: '145 26% 30%',
    700: '148 26% 24%',
    800: '148 25% 19%',
    900: '150 24% 16%',
    950: '150 26% 9%',
  },
  sage: {
    50: '100 18% 97%',
    100: '98 21% 93%',
    200: '99 18% 85%',
    300: '101 18% 73%',
    400: '99 16% 58%',
    500: '101 13% 44%',
    600: '100 18% 36%',
    700: '101 17% 29%',
    800: '101 15% 24%',
    900: '104 15% 20%',
    950: '107 18% 10%',
  },
  outback: {
    50: '30 44% 96%',
    100: '33 43% 92%',
    200: '30 44% 83%',
    300: '30 43% 72%',
    400: '26 42% 63%',
    500: '23 42% 53%',
    600: '20 37% 48%',
    700: '17 26% 40%',
    800: '14 35% 34%',
    900: '14 32% 28%',
    950: '12 35% 15%',
  },
  tuscany: {
    50: '30 56% 96%',
    100: '30 52% 92%',
    200: '27 49% 83%',
    300: '24 49% 72%',
    400: '21 49% 61%',
    500: '18 48% 53%',
    600: '14 38% 45%',
    700: '11 30% 40%',
    800: '9 41% 34%',
    900: '9 38% 28%',
    950: '6 41% 15%',
  },
  meltwater: {
    50: '180 26% 96%',
    100: '185 27% 90%',
    200: '187 27% 82%',
    300: '189 27% 69%',
    400: '189 24% 50%',
    500: '189 20% 43%',
    600: '193 26% 36%',
    700: '195 23% 31%',
    800: '195 20% 27%',
    900: '197 17% 24%',
    950: '195 21% 15%',
  },
  navy: {
    50: '214 18% 96%',
    100: '214 18% 90%',
    200: '214 18% 82%',
    300: '209 27% 69%',
    400: '214 18% 50%',
    500: '214 18% 43%',
    600: '214 18% 36%',
    700: '214 18% 31%',
    800: '214 18% 27%',
    900: '214 18% 24%',
    950: '214 18% 15%',
  },
  // neutral
  gray: {
    50: '0 0% 98%',
    100: '0 0% 96%',
    200: '0 0% 90%',
    300: '0 0% 83%',
    400: '0 0% 64%',
    500: '0 0% 45%',
    600: '0 0% 32%',
    700: '0 0% 25%',
    750: '0 0% 19%',
    800: '0 0% 15%',
    900: '0 0% 9%',
    950: '0 0% 4%',
  },
}
